export const userQuery = ({ userId, companyId }) => `
  {
    user(id: "${userId}") {
      id
      pid
      name
      email
      picture
      companyId
      status
      company_name
      allGroupIds
      company_subdomain
      hasAllRequiredInfo
      roles
      customProperties {
        customProperty {
          pid
          name
          isRequired
        }
        values {
          id
          value
        }
      }
      manages {
        pid
        name
      }
      teacherCourses {
        pid
        name
      }
      teacherActivities {
        pid
        name
        activityType
      }
      myRoles {
        pid
        name
        modelPermissions {
          type
          permissions
        }
      }
    }
    company(id: "${companyId}") {
      pid
      name
      headerImage
      includeRecommendation
      parentCompanyId
      homepageMetadata
      requiredAssetCustomProperties {
        pid
        name
        values {
          id
          value
        }
      }
    }
  }
`;
